export function GlobalScripts(): JSX.Element {
  return <></>;
}
